import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestLogin } from "./login.request";
import { LoginResponse } from "./login.types";

const useLogin = (
  options?: MutationOptions<LoginResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestLogin,
    ...options
  });
};

export default useLogin;
